import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'ngForTimes'})
export class NgForTimes implements PipeTransform {
	public transform(value): any {
		const res = [];
		for (let i = 0; i < value; i++) {
			res.push(i);
		}

		return res;
	}
}
